<template>
	<div>
		<canvas tabindex="0" :height="height" :width="width" ref="editor" />
	</div>
</template>

<script>
import { fabric } from "fabric"
import ColorHash from "color-hash"

/**
 * todo: add shapes here
 */
const shapeFactory = ({ type, ...data }) => {
	if (type === "box") {
		return new fabric.Rect(data)
	}
}

const toggleLock = (object, value = true) => {
	object.lockMovementY = value
	object.lockMovementX = value
	object.lockUniScaling = value
	object.lockRotation = value
}

const drawingToFabric = (drawing, scale) => {
	const width = (drawing.point2.x - drawing.point1.x) * scale
	const height = (drawing.point2.y - drawing.point1.y) * scale
	const color = new ColorHash()
	return {
		type: "box",
		id: drawing.id,
		left: drawing.point1.x * scale,
		top: drawing.point1.y * scale,

		width,
		height,

		point1: drawing.point1,
		point2: drawing.point2,

		fill: `rgba(${color.rgb(drawing.id)}, 0.5)`,
		liquidSource: drawing.liquidSource,
		hasRotatingPoint: false,
		hasBorders: false,
		borderColor: `rgba(${color.rgb(drawing.id)}, 0.5)`,
		textAlignment: drawing.textAlignment,
		verticalAlignment: drawing.verticalAlignment
	}
}

const render = function(newVal, oldVal) {
	this.renderAll()
}

export default {
	props: {
		height: {
			type: Number
		},
		width: {
			type: Number
		},
		type: {
			type: String,
			default: "box"
		},
		drawings: {
			type: Array
		},
		page: {
			type: Number,
			default: 1
		},
		scale: {
			type: Number,
			default: 1
		},
		activeTool: {
			type: String
		},
		activeObject: {
			type: Object
		}
	},
	data: () => ({
		editor: undefined,
		drawingBox: {},
		mouseDown: {},
		mouseUp: {}
	}),
	methods: {
		async renderAll() {
			this.editor.clear()

			this.editor.setHeight(this.height)
			this.editor.setWidth(this.width)

			const drawings = this.drawings.filter(
				drawing => drawing.page === this.page
			)

			const rendered = await drawings.map(drawing => {
				const renderedDrawing = shapeFactory(
					drawingToFabric(drawing, this.scale)
				)

				if (this.activeObject?.id === renderedDrawing.id) {
					this.editor.add(renderedDrawing).setActiveObject(renderedDrawing)
				} else {
					this.editor.add(renderedDrawing)
				}

				return renderedDrawing
			})

			await this.editor.renderAll()
		}
	},
	mounted() {
		this.editor = new fabric.Canvas(this.$refs.editor, {
			selection: false
		})

		this.editor.setHeight(this.height)
		this.editor.setWidth(this.width)

		this.renderAll()

		const objectEvents = [
			"object:modified",
			"object:moved",
			"object:rotated",
			"object:skewed"
		]
		objectEvents.forEach(event => {
			this.editor.on(event, options => {
				if (this.activeTool === "edit") {
					this.$emit("savePdfDrawing", options)
				}
			})
		})

		const doingEvents = ["object:scaling", "object:moving"].forEach(event => {
			const updateDrawing = options => {
				if (this.activeTool === "edit") {
					this.$emit("updateDrawing", options)
				}
			}
			this.editor.on(event, options => {
				requestAnimationFrame(function() {
					updateDrawing(options)
				})
			})
		})

		this.editor.on("mouse:down", options => {
			if (this.activeTool === "edit") {
				if (options.target) {
					// already a target
					const object = this.editor.getActiveObject()
					toggleLock(object, false)
					this.$emit("selectObject", options.target)
					return
				}
				this.mouseDown = options.pointer
			}

			// add liquid
			if (this.activeTool === "liquid") {
				if (options.target) {
					const object = this.editor.getActiveObject()
					toggleLock(object, true)

					this.editor.discardActiveObject()
					this.$emit("editLiquid", options)
				}
			}
		})

		this.editor.on("mouse:up", options => {
			this.mouseUp = options.pointer

			if (
				this.mouseUp.x === this.mouseDown.x &&
				this.mouseUp.y === this.mouseDown.y
			)
				return

			if (this.activeTool === "edit") {
				if (options.target) {
					// already a target
					const object = this.editor.getActiveObject()
					toggleLock(object, false)
					this.$emit("selectObject", options.target)
					return
				}
			}

			this.drawingBox = {
				liquidSource: "",
				point1: {
					x: this.mouseDown.x / this.scale,
					y: this.mouseDown.y / this.scale
				},
				point2: {
					x: this.mouseUp.x / this.scale,
					y: this.mouseUp.y / this.scale
				}
			}

			this.$emit("addDrawing", { ...this.drawingBox, type: "box" })
		})
	},
	watch: {
		page: render,
		width: render,
		scale: render,

		activeObject: function() {
			this.renderAll()
		},

		drawings: {
			handler: function(newVal, oldVal) {
				this.renderAll()
			},
			deep: true
		}
	}
}
</script>

<style>
</style>